import React from "react";

const GLYPHS = ["♩", "♪", "♫", "♬", "♭", "♯", "𝄞"];

// Ambient floating music notes. Decorative only (pointer-events-none).
export const AnimatedNotes = ({ count = 14, className = "", spread = false }) => {
  const notes = React.useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        glyph: GLYPHS[i % GLYPHS.length],
        left: Math.round((i * 97 + 7) % 100),
        delay: ((i * 1.3) % 8).toFixed(2),
        duration: (7 + ((i * 1.7) % 6)).toFixed(2),
        size: 16 + ((i * 7) % 30),
        bottom: spread ? `${(i * 37 + 5) % 95}%` : `${-((i * 13) % 40)}px`,
      })),
    [count, spread]
  );
  return (
    <div aria-hidden className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}>
      {notes.map((n, i) => (
        <span
          key={i}
          className="animate-float-note absolute text-primary/40"
          style={{
            left: `${n.left}%`,
            bottom: n.bottom,
            fontSize: `${n.size}px`,
            animationDelay: `${n.delay}s`,
            animationDuration: `${n.duration}s`,
          }}
        >
          {n.glyph}
        </span>
      ))}
    </div>
  );
};

export default AnimatedNotes;
